import '../../../shared/types/colors/index.js';
export { Coverage } from '../../../shared/types/common/index.js';

var VerticalAlign;
(function (VerticalAlign) {
    VerticalAlign["Top"] = "top";
    VerticalAlign["Middle"] = "middle";
    VerticalAlign["Bottom"] = "bottom";
})(VerticalAlign || (VerticalAlign = {}));
var HorizontalAlign;
(function (HorizontalAlign) {
    HorizontalAlign["Left"] = "left";
    HorizontalAlign["Center"] = "center";
    HorizontalAlign["Right"] = "right";
})(HorizontalAlign || (HorizontalAlign = {}));

export { HorizontalAlign, VerticalAlign };
